// import { AddTask } from '@components/ToDo/AddTask';
import { DefaultLayout } from '../layouts';
import { Navigate } from 'react-router-dom';
import React from 'react';
import Dashboard from '../pages/Dashboard/Dashboard';
import AllBusinesses from '../pages/AllBusinesses/AllBusinesses';
import Setup from '../pages/Setup/Setup';
import Account from '../pages/Acount/Account';
import Help from '../pages/Help/Help';
import BusinessDetails from '../pages/AllBusinesses/BusinessDetails';
import ContactUs from '../pages/ContactUs/ContactUs';
import ReferralAdd from '../pages/Referrals/ReferralAdd';
import ReferUsList from '../pages/ReferReferUs/ReferUsList';
import ReferUsNetworkList from '../pages/ReferUsNetwork/ReferUsNetworkList';
import Sms from '../pages/Sms/Sms';
import EditSmsTemplate from '../pages/Sms/EditSmsTemplate';
import SmsForm from '../pages/Sms/SmsForm';
import MyReferrers from '../pages/MyReferrer/MyReferrer';
import Referrals from '../pages/Referrals/Referrals';
import BusinessCategory from '../pages/BusinessCategory/BusinessCategory';
import PlatformRegistration from '../pages/Platform/PlatformRegistration';
import PlatformList from '../pages/PlatformList/PlatformList';
import ConsentPage from '../pages/Consent/ConsentPage';

export const GlobalAdminRoutes = [
    {
        path: '/',
        exact: true,
        layout: DefaultLayout,
        component: () => <Navigate to="/dashboard" replace />,
    },
    {
        path: '/dashboard',
        exact: true,
        layout: DefaultLayout,
        component: Dashboard,
    },
    {
        path: '/super-admin/all-businesses',
        exact: true,
        layout: DefaultLayout,
        component: AllBusinesses,
    },
    {
        path: '/super-admin/view-business-details',
        exact: true,
        layout: DefaultLayout,
        component: BusinessDetails,
    },
    {
        path: '/super-admin/view-referral',
        exact: true,
        layout: DefaultLayout,
        component: ReferralAdd,
    },
    {
        path: '/super-admin/setup',
        exact: true,
        layout: DefaultLayout,
        component: Setup,
    },
    {
        path: '/super-admin/refer-admin-referus',
        exact: true,
        layout: DefaultLayout,
        component: ReferUsList,
    },
    {
        path: '/super-admin/my-referrers',
        exact: true,
        layout: DefaultLayout,
        component: MyReferrers,
    },
    {
        path: '/super-admin/my-referrals',
        exact: true,
        layout: DefaultLayout,
        component: Referrals,
    },
    {
        path: '/super-admin/referus-network',
        exact: true,
        layout: DefaultLayout,
        component: ReferUsNetworkList,
    },
    {
        path: '/super-admin/contact-us',
        exact: true,
        layout: DefaultLayout,
        component: ContactUs,
    },
    {
        path: '/super-admin/account',
        exact: true,
        layout: DefaultLayout,
        component: Account,
    },
    {
        path: '/super-admin/help',
        exact: true,
        layout: DefaultLayout,
        component: Help,
    },
    {
        path: '/super-admin/sms',
        exact: true,
        layout: DefaultLayout,
        component: Sms,
    },
    {
        path: '/super-admin/edit-sms-template',
        exact: true,
        layout: DefaultLayout,
        component: EditSmsTemplate  ,
    },
    {
        path: '/super-admin/add-sms-template',
        exact: true,
        layout: DefaultLayout,
        component: SmsForm 
    },
    {
        path: '/super-admin/business-category',
        exact: true,
        layout: DefaultLayout,
        component: BusinessCategory 
    },
    {
        path: '/super-admin/platform-registration',
        exact: true,
        layout: DefaultLayout,
        component: PlatformRegistration
    },
    {
        path: '/super-admin/platform-list',
        exact: true,
        layout: DefaultLayout,
        component: PlatformList
    },
];
